import { useEffect, useState } from "react";
import "./ClockWidget.css";

function pad(n) {
  return String(n).padStart(2, "0");
}

function getSnapshot() {
  const now = new Date();

  const localTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
    now.getSeconds()
  )}`;

  const zuluTime = `${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(
    now.getUTCSeconds()
  )}Z`;

  const localDate = now.toLocaleDateString(undefined, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  let tzLabel = "Local";
  try {
    tzLabel =
      Intl.DateTimeFormat().resolvedOptions().timeZone || "Local";
  } catch {
    tzLabel = "Local";
  }

  return {
    localTime,
    zuluTime,
    localDate,
    tzLabel,
    isoLocal: now.toISOString(),
  };
}

export default function ClockWidget() {
  const [snapshot, setSnapshot] = useState(getSnapshot);

  useEffect(() => {
    const id = setInterval(() => {
      setSnapshot(getSnapshot());
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const { localTime, zuluTime, localDate, tzLabel, isoLocal } = snapshot;

  return (
    <section className="clock-widget" aria-label="Current time">
      <div className="clock-row">
        <span className="clock-label">{tzLabel}</span>
        <time
          className="clock-time"
          dateTime={isoLocal}
          aria-label={`Local time ${localTime} ${tzLabel}`}
        >
          {localTime}
        </time>
      </div>

      <div className="clock-row">
        <span className="clock-label">UTC / Zulu</span>
        <time
          className="clock-time"
          dateTime={isoLocal}
          aria-label={`Zulu time ${zuluTime}`}
        >
          {zuluTime}
        </time>
      </div>

      <div className="clock-date">
        <span className="clock-label">Date</span>
        <time className="clock-date-value" dateTime={isoLocal}>
          {localDate}
        </time>
      </div>
    </section>
  );
}
